/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarcatoreInsertDto } from '../../models/marcatore-insert-dto';

export interface ApiMarcatoreMarcatoreInsertPost$Params {
    /**
     * Oggetto contenente i dati del nuovo marcatore
     */
    body: MarcatoreInsertDto;
}

export function apiMarcatoreMarcatoreInsertPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiMarcatoreMarcatoreInsertPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreMarcatoreInsertPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: parseFloat(String((r as HttpResponse<any>).body)),
            }) as StrictHttpResponse<number>;
        }),
    );
}

apiMarcatoreMarcatoreInsertPost.PATH = '/api/marcatore/marcatore-insert';
